import localFont from "next/font/local";

export const ortoRnids = localFont({
  src: [
    {
      path: "./assets/OrtoRNIDS-Regular.woff2",
      weight: "400",
      style: "normal",
    },
    {
      path: "./assets/OrtoRNIDS-Bold.woff2",
      weight: "700",
      style: "normal",
    },
  ],
  variable: "--font-orto-rnids",
  fallback: ["Arial", "sans-serif"],
  adjustFontFallback: false,
});

export const rootFontVariables = ortoRnids.variable;
